export const getToken = async () => {
  return new Promise(async (next, error) => {
    try {
      // console.log("token is", await AsyncStorage.getItem('token'))
      next(await localStorage.getItem("token"));
    } catch (e) {
      next(null);
    }
  });
};
export const getTokenHeader = (token) => {
  if (!token) return {};
  return {
    headers: { Authorization: "Bearer " + token },
  };
};
export const getTokenHeaderFile = (token) => {
  return {
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/json",
      "content-type": "multipart/form-data;",
    },
  };
};
